import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ColDef } from '@ag-grid-community/core'
import { StatisticalAnalysisDatasourceExternalDetail } from '@/modules/statistical-analysis-module/handlers/statistical-analysis-datasource'
import { Nullable } from '@/shared/types/app.types'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisDossiersDatasourceResponsesTypes, StatisticalAnalysisDynamicObject, StatisticalAnalysisExternalListTypes, StatisticalAnalysisViewDetailTableGroupingColumns } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisViewDetailTableFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.model'
import { store } from '@/store/store'
import { StatisticalAnalysisSampleTagsStatisticsDossierBaseRequest, StatisticalAnalysisSampleTagsStatisticsDossierDetailExternalViewTable, StatisticalAnalysisSampleTagsStatisticsDossierDetailViewTableContentCase } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.dto'
import { sampleTagsStatisticsDossierService } from '@/modules/statistical-analysis-module/services/sample-tags-dossier/sample-tags-dossier.service'
import { chain, isNil } from 'lodash'
import { StatisticalAnalysisSampleTagsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/labeled-samples-dossier/labeled-samples-dossier.model'
import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { getExternalColumnsEntity, getLabAndCaseId, parseGroupingParams } from '@/modules/statistical-analysis-module/shared/helpers/helpers'
import { InfinitePaginatorResponse } from '@/shared/resources/infinite-datasources/infinite-resource.model'

export class StatisticalAnalysisHandlerDatasourceSampleTagsDossierDetailList extends StatisticalAnalysisDatasourceExternalDetail<StatisticalAnalysisExternalListTypes> {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailTableFilters>
    protected row: StatisticalAnalysisSampleTagsStatisticsDossierDetailViewTableContentCase

    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailTableFilters>, row: StatisticalAnalysisDossiersDatasourceResponsesTypes) {
        super()
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
        this.row = row as StatisticalAnalysisSampleTagsStatisticsDossierDetailViewTableContentCase
    }

    public getGridColumns(): ColDef[] {
        return getExternalColumnsEntity((this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters?.typeSearch as StatisticalAnalysisSidebarItemCombo)?.id as StatiscalAnalysisTypeCases)
    }

    public async paginator(filterModel: CommonFilterModel, params: CommonParams, scrollId: string): Promise<InfinitePaginatorResponse<StatisticalAnalysisExternalListTypes>> {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisSampleTagsDossierExternalInfo
        const baseRequest: StatisticalAnalysisSampleTagsStatisticsDossierBaseRequest = sampleTagsStatisticsDossierService.getBaseRequest(sidebarFilter)
        const tagId = sidebarFilter.trackingGeneralSelected?.key as number
        const groupingParams: StatisticalAnalysisDynamicObject = chain(this.row)
            .omitBy((_value: unknown, key: string) => {
                return key.startsWith('totalCases') || key.startsWith('totalSamples')
            })
            .omitBy((value: unknown) => value === null)
            .reduce((aggr: StatisticalAnalysisDynamicObject, value: unknown) => {
                return parseGroupingParams(aggr, value as StatisticalAnalysisViewDetailTableGroupingColumns)
            }, {})
            .value()
        const response: StatisticalAnalysisSampleTagsStatisticsDossierDetailExternalViewTable = await sampleTagsStatisticsDossierService.getExternalViewDetailList(
            filterModel,
            params,
            baseRequest,
            groupingParams,
            tagId,
            scrollId,
            this.getTotalElements()
        )
        if (isNil(this.getTotalElements())) {
            this.setTotalElements(response.scrollPage.totalElements)
        }
        return {
            content: response.content,
            scrollPage: {
                scrollId: encodeURIComponent(JSON.stringify(response.scrollPage.scrollId)),
                size: response.scrollPage.size,
                totalElements: response.scrollPage.totalElements
            }
        }
    }

    public getLabAndCaseId(selectedRow: StatisticalAnalysisExternalListTypes): [number, number] {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisSampleTagsDossierExternalInfo
        const typeCase = sidebarFilter?.typeSearch?.id as StatiscalAnalysisTypeCases
        return getLabAndCaseId(typeCase, selectedRow)
    }
}
